import React, { useContext, useCallback, useEffect, useRef } from 'react';
import { Alert, AlertIcon } from '@chakra-ui/react';
import { ProfileContext } from 'core/services/store/profile/store';
import ProfileServices from 'core/services/store/profile/services';
import * as ProfileActions from 'core/services/store/profile/actions';
import { Button, Flex, Stack } from '@chakra-ui/react';
import notificationPreferencesFormData from 'base/defaults/forms/notificationPreferences.json';
import GlobalFormComponent from 'core/components/forms/GlobalFormComponent';
// import * as Actions from 'core/services/store/form/actions';

const mappedFields = {
  notificationWhatsapp: 'whatsappNotification',
  notificationAlerts: 'propertyAlerts',
  notificationEmail: 'emailNotification',
};

const NotificationPreferencesForm = ({ ...props }) => {
  const [state, dispatch] = useContext(ProfileContext);
  const profile = state?.profile;
  const services = ProfileServices(dispatch, ProfileActions);

  const onChange = useCallback(
    (field, value) => {
      services.updateProfile({
        id: profile.id,
        [mappedFields[field]]: value,
      });
    },
    [services, profile]
  );

  if (!profile) {
    return null;
  }

  return (
    <Stack spacing="5" {...props}>
      <GlobalFormComponent
        formFields={notificationPreferencesFormData}
        formStateType={profile}
        onChange={onChange}
        noSubmitButton
      />
      {state.success && (
        <Alert status="success">
          <AlertIcon />
          Your profile has been updated
        </Alert>
      )}
    </Stack>
  );
};

export default {
  component: NotificationPreferencesForm,
  provide: ['form'],
  props: {
    pt: 5,
  },
};
